import { connect } from 'react-redux'
import * as action from '../../state/image/action'
import * as selector from '../../state/image/selector'
import * as customerSelector from '../../state/detail/selector'
import ImageUpload from '../imageUpload/ImageUpload'
import { selectCanSeeImages } from '../../../security/state/auth/selector'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CUSTOMER_IMAGE_UPLOAD_WIDGET } from '../../../process/ui-definition/process-ui'

const canSeeImages = (state) => {
    if (!currentUserHasAccess(CUSTOMER_IMAGE_UPLOAD_WIDGET)) {
        return false
    }
    return selectCanSeeImages(state)
}

const mapStateToProps = (state) => {
    return {
        customerId: customerSelector.selectCustomerId(state),
        canSeeImages: canSeeImages(state),
        imageVersionList: selector.selectOrderedImageVersionList(state),
        showImages: selector.selectShowImages(state),
        uploadingImages: selector.selectUploadingImages(state),
        retryImages: selector.selectRetryImages(state),
    }
}

const mapDispatchToProps = {
    findImageVersion: action.findRecentImageVersion,
    uploadCustomerImage: action.reuploadCustomerImage,
    retryUploadFromLocalStorage: action.retryUploadFromLocalStorage,
    rotateCustomerImage: action.rotateCustomerImage,
    toggleImageView: action.toggleImageView,
    setImageTypeMetaData: action.setImageTypeMetaData,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/CustomerImageReuploadWidgetContainer.js